var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "ui tiny modal amazonGiftDialog",
      attrs: { id: "amazon-gift-dialog" },
    },
    [
      _c("div", { staticClass: "image" }, [
        _c("img", {
          staticClass: "pcOnly",
          attrs: { src: _vm.imageUrl("/amazon_popup_pc.png") },
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "spOnly",
          attrs: { src: _vm.imageUrl("/amazon_popup_sp.png") },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c("div", { staticClass: "close", on: { click: _vm.closeDialog } }, [
          _vm._v("閉じる"),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }